import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    tile: 'bg-grey-90 @hactive:(b-black c-grey-20) py-8 px-10 md:px-6 lg:px-20'
  }
} satisfies VfConfig['tile']
